export function randomGradient() {
  const hue1 = Math.floor(Math.random() * 360)
  const hue2 = (hue1 + Math.floor(Math.random() * 40) + 20) % 360

  return `linear-gradient(
    75deg,
    hsl(${hue1}, 70%, 35%),
    hsl(${hue2}, 70%, 30%)
  )`
}
